import React, { Fragment, PureComponent } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';

import Actions from 'components/assets/actions';

class AssetsActions extends PureComponent {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    canDisable: PropTypes.bool,
    canEnable: PropTypes.bool,
    canEdit: PropTypes.bool,
    canRequestUpdate: PropTypes.bool,
    companyId: PropTypes.string,
    handleEnableAsset: PropTypes.func,
    subcompanyId: PropTypes.string,
    handleSendTokenAsign: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <div className="dropdown">
      <button
        className="btn btn-secondary dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        {this.props.t('common.actions')}
      </button>
      <div className="dropdown-menu p-2" aria-labelledby="dropdownMenuButton">
        {this.props.canEdit && !this.props.asset.disabled && (
          <Actions.Edit
            assetId={this.props.asset.id}
            companyId={this.props.companyId}
            subcompanyId={this.props.subcompanyId}
          />
        )}
        {this.props.canEdit &&
          this.props.asset._employee != null &&
          !this.props.asset.validated &&
          !this.props.asset.disabled && (
            <Actions.SendTokenAsign
              // sendTokenAsign
              isLoading={this.props.isLoading}
              handleSendTokenAsign={this.props.handleSendTokenAsign}
              asset={this.props.asset}
              assetId={this.props.asset.id}
              companyId={this.props.companyId}
              subcompanyId={this.props.subcompanyId}
            />
          )}
        {this.props.canRequestUpdate && !this.props.asset.disabled && (
          <Actions.RequestUpdate
            assetId={this.props.asset.id}
            companyId={this.props.companyId}
            subcompanyId={this.props.subcompanyId}
          />
        )}

        {this.props.canDisable && !this.props.asset.disabled && (
          <Actions.Disable
            assetId={this.props.asset.id}
            companyId={this.props.companyId}
            subcompanyId={this.props.subcompanyId}
          />
        )}

        {this.props.canEnable && this.props.asset.disabled && (
          <Actions.Enable
            asset={this.props.asset}
            companyId={this.props.companyId}
            subcompanyId={this.props.subcompanyId}
            handleClick={this.props.handleEnableAsset}
          />
        )}

        <Actions.Detail
          assetId={this.props.asset.id}
          companyId={this.props.companyId}
          subcompanyId={this.props.subcompanyId}
        />
      </div>
    </div>
  );
}

export default translate()(AssetsActions);



// WEBPACK FOOTER //
// src/components/assets/AssetsActions.js